import parse from "html-react-parser";
import { Flex, Text, Box } from "@chakra-ui/react";

export default function AdditionalInfo({ weight, dimensions, attributes }) {
  const TableItem = ({ title, options }) => {
    return (
      <Flex
        py={3}
        width="100%"
        borderBottomWidth={2}
        flexDirection={{ base: "column", sm: "row", lg: "row" }}
      >
        <Box width={{ base: "100%", sm: "30%", lg: "20%" }}>
          <Text variant="cartBold">{title}</Text>
        </Box>
        <Box
          flexDirection="column"
          width={{ base: "100%", sm: "70%", lg: "80%" }}
        >
          {options.map((option, index) => {
            const items = option.split("\n");
            return (
              <div key={index}>
                {items.map((item, index) => (
                  <Text key={index} variant="productCardDescription">
                    {parse(item)}
                  </Text>
                ))}
              </div>
            );
          })}
        </Box>
      </Flex>
    );
  };

  const Dimension = ({ dimensions }) => (
    <Flex
      py={3}
      width="100%"
      borderBottomWidth={2}
      flexDirection={{ base: "column", sm: "row", lg: "row" }}
    >
      <Box width={{ base: "100%", sm: "30%", lg: "20%" }}>
        <Text variant="cartBold">Dimensions</Text>
      </Box>
      <Box width={{ base: "100%", sm: "70%", lg: "80%" }}>
        <Text variant="productCardDescription">
          {`${dimensions.length} x ${dimensions.width} x ${dimensions.height} cm`}
        </Text>
      </Box>
    </Flex>
  );
  const Weight = ({ weight }) => (
    <Flex
      py={3}
      width="100%"
      borderBottomWidth={2}
      flexDirection={{ base: "column", sm: "row", lg: "row" }}
    >
      <Box width={{ base: "100%", sm: "30%", lg: "20%" }}>
        <Text variant="cartBold">Weight</Text>
      </Box>
      <Box width={{ base: "100%", sm: "70%", lg: "80%" }}>
        <Text variant="productCardDescription">{weight} g</Text>
      </Box>
    </Flex>
  );

  return (
    <>
      {weight && <Weight weight={weight} />}
      {dimensions && <Dimension dimensions={dimensions} />}
      {attributes.map((attribute, index) => {
        const { name, options } = attribute;
        return (
          <TableItem key={`${name}-${index}`} title={name} options={options} />
        );
      })}
    </>
  );
}
